import React from 'react';
import { useStyleConfig, vui } from '../core';
import T from '../t';
import { cs } from '../utils';
import { useLinkContext } from './context';
/** Displays text of the Link. */
export const LinkText = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Link', useLinkContext());
    return (React.createElement(T, { className: cs('vui-linkText', className), fontSize: "inherit", ref: ref, transitionDuration: "unset", ...styles.text, ...rest }));
});
export default LinkText;
